import { render } from "./TrainingAnnouncements.vue?vue&type=template&id=f1938e66"
import script from "./TrainingAnnouncements.vue?vue&type=script&lang=js"
export * from "./TrainingAnnouncements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__